/*
 * Packing-video picker behaviour for the OBW product section.
 *
 * Which video pills show is handled by CSS from the variant data (see
 * snippets/obw-video-option-roles.liquid and the [data-obw-option="video"] rules
 * in obw-custom.css). This script only keeps the selection sensible when the
 * shopper changes another option:
 *   - remembers the shopper's last paid/none video choice and restores it when
 *     it exists again (e.g. 5 scoops -> 3 scoops brings back "Add Video");
 *   - if the selected video value has no variant for the current selection,
 *     picks the remembered choice, else the cheapest one, else the only one.
 * Nothing here depends on option names, value names, tiers or prices.
 */
(function () {
  'use strict';

  var VIDEO = '[data-obw-option="video"]';
  var section = null;
  var remembered = null;

  function roleOf(input) {
    var label = input.closest('[data-obw-video-role]');
    return label ? label.getAttribute('data-obw-video-role') : '';
  }

  function exists(input) {
    return input.hasAttribute('data-variant-id');
  }

  function fadeBuyControlsUntilUpdate() {
    var els = [
      section.querySelector('add-to-cart-component'),
      section.querySelector('.quantity-selector-wrapper')
    ].filter(Boolean);
    if (!els.length) return;

    els.forEach(function (el) {
      el.style.transition = '';
      el.style.opacity = '0';
    });
    section.addEventListener('variant:update', function () {
      els.forEach(function (el) {
        el.style.transition = 'opacity 0.15s ease';
        el.style.opacity = '1';
      });
    }, { once: true });
  }

  function sync() {
    var field = section && section.querySelector(VIDEO);
    if (!field) return;

    var inputs = Array.prototype.slice.call(field.querySelectorAll('input[type="radio"]'));
    var available = inputs.filter(exists);
    if (!available.length) return;

    // Values with no variant for this selection can't be chosen (CSS hides or dims them).
    inputs.forEach(function (input) { input.disabled = !exists(input); });

    var checked = field.querySelector('input[type="radio"]:checked');

    if (remembered === null) {
      remembered = checked && roleOf(checked) !== 'included'
        ? checked.value
        : (inputs.filter(function (i) { return roleOf(i) === 'none'; })[0] || {}).value || null;
    }

    var target = null;
    var rememberedInput = available.filter(function (i) { return i.value === remembered; })[0];
    if (rememberedInput) {
      target = rememberedInput;
    } else if (!checked || !exists(checked)) {
      target = available.filter(function (i) { return roleOf(i) === 'none'; })[0] || available[0];
    }

    if (target && target !== checked) {
      fadeBuyControlsUntilUpdate();
      target.disabled = false;
      target.click();
    }
  }

  function init() {
    var field = document.querySelector(VIDEO);
    section = field ? field.closest('.shopify-section') : null;
    if (!section || section.hasAttribute('data-obw-video-toggle')) return;
    section.setAttribute('data-obw-video-toggle', '');

    // Record the shopper's own video choice before Horizon re-renders.
    section.addEventListener('change', function (e) {
      var input = e.target;
      if (!input || !input.closest || !input.closest(VIDEO)) return;
      if (roleOf(input) !== 'included') remembered = input.value;
    });

    // Runs after Horizon finishes re-rendering the picker.
    section.addEventListener('variant:update', sync);

    // Initial run once Horizon's custom elements have rendered.
    if (document.readyState === 'complete') {
      setTimeout(sync, 200);
    } else {
      window.addEventListener('load', function () { setTimeout(sync, 200); });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the section; re-attach to the new element.
  document.addEventListener('shopify:section:load', function () {
    remembered = null;
    init();
  });
})();
